module.exports = __webpack_public_path__ + "media/images/img_freedial-3dc0d54a5cb1642ee84a24a67011a79a.png";